export const UPDATE_CALENDAR_CONTROLS = 'hg/calendar/UPDATE_CALENDAR_CONTROLS';

export const initialState = {
  calendarControls: {
    timeSlots: [],
    page: 0,
    step: 5
  }
};

export const calendar = (state = initialState, action = {}) => {
  switch (action.type) {

    case UPDATE_CALENDAR_CONTROLS:
      return {
        ...state,
        calendarControls: {
          ...state.calendarControls,
          ...action.calendarControls
        }
      };

    default:
      return state;
  }
};

// Action Creators
export const updateCalendarControls = calendarControls => {
  return {
    type: UPDATE_CALENDAR_CONTROLS,
    calendarControls: calendarControls
  };
};

export default calendar;



/** WEBPACK FOOTER **
 ** ./client/shared/packages/TimeSlotCalendar/src/redux/calendar.js
 **/